module.exports = __webpack_public_path__ + "saldo-por-data.png?5c860cca5e6bfa994a9e21780b62edb5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty/saldo-por-data.png
// module id = 954
// module chunks = 0